export const WHATSAPP_NUMBER = "393803805349";

export const EVENT_TYPES = [
  "Compleanno",
  "Laurea",
  "Aperitivo Aziendale",
  "Battesimo / Comunione",
  "Addio al Celibato/Nubilato",
  "Anniversario",
  "Altro",
];

export const STATUS_LABELS = {
  bozza: "Bozza",
  nuovo: "Nuovo",
  in_revisione: "In revisione",
  approvato: "Approvato",
  acconto_ricevuto: "Acconto ricevuto",
  confermato: "Confermato",
  completato: "Completato",
  rifiutato: "Rifiutato",
};

export const STATUS_STYLES = {
  bozza: "bg-gray-100 text-gray-700 border-gray-200",
  nuovo: "bg-blue-100 text-blue-800 border-blue-200",
  in_revisione: "bg-amber-100 text-amber-800 border-amber-200",
  approvato: "bg-emerald-100 text-emerald-800 border-emerald-200",
  acconto_ricevuto: "bg-teal-100 text-teal-800 border-teal-200",
  confermato: "bg-indigo-100 text-indigo-800 border-indigo-200",
  completato: "bg-gray-100 text-gray-800 border-gray-200",
  rifiutato: "bg-rose-100 text-rose-800 border-rose-200",
};

export const fmtEur = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);

export function computeTotals(items, adminDiscount = 0) {
  let total = 0, vat10 = 0, vat22 = 0;
  items.forEach((it) => {
    const line = it.price * it.qty * (1 - (it.discount || 0) / 100);
    const share = line * (1 - (adminDiscount || 0) / 100);
    total += line;
    const net = share / (1 + it.vat / 100);
    if (it.vat === 10) vat10 += share - net;
    else vat22 += share - net;
  });
  total *= 1 - (adminDiscount || 0) / 100;
  return {
    total: Math.round(total * 100) / 100,
    subtotal_net: Math.round((total - vat10 - vat22) * 100) / 100,
    vat_10: Math.round(vat10 * 100) / 100,
    vat_22: Math.round(vat22 * 100) / 100,
  };
}

export function buildItems(catalog, selections, guestsCount, barGuests = null) {
  return Object.entries(selections)
    .filter(([, qty]) => qty > 0)
    .map(([id, qty]) => {
      const p = catalog.find((c) => c.id === id);
      if (!p) return null;
      return {
        product_id: p.id,
        name: p.name,
        category: p.category,
        price: p.price,
        vat: p.vat,
        unit: p.unit,
        qty: p.unit === "persona" ? (p.category === "Bar" && barGuests != null ? barGuests : guestsCount) : qty,
        discount: p.discount || 0,
      };
    })
    .filter(Boolean);
}

export const ROOM_NAMES = { interna: "Sala Interna", deorsi: "Sala Dehors" };

export function salaSummary(sala) {
  if (!sala) return "";
  if (sala.choice) {
    const legacy = {
      interna: "Sala Interna (senza esclusiva)",
      deorsi: "Sala Dehors (senza esclusiva)",
      excl_interna: "Sala Interna in uso esclusivo",
      excl_deorsi: "Sala Dehors in uso esclusivo",
      excl_entrambe: "Entrambe le sale in uso esclusivo",
    };
    return legacy[sala.choice] || "";
  }
  if (!sala.rooms) return "";
  if (sala.rooms === "entrambe") {
    if (sala.excl_interna && sala.excl_deorsi) return "Entrambe le sale in uso esclusivo";
    const p = (r, ex) => `${ROOM_NAMES[r]}${ex ? " in esclusiva" : ""}`;
    return `${p("interna", sala.excl_interna)} + ${p("deorsi", sala.excl_deorsi)}`;
  }
  const ex = sala.rooms === "interna" ? sala.excl_interna : sala.excl_deorsi;
  return `${ROOM_NAMES[sala.rooms]}${ex ? " in uso esclusivo" : " (senza esclusiva)"}`;
}

export function salaExclusiveItems(sala, config) {
  if (!sala || sala.choice) return [];
  const mk = (name, price) => ({ product_id: "sala-esclusiva", name, category: "Sala", price, vat: 22, unit: "fisso", qty: 1, discount: 0 });
  const wantI = sala.excl_interna && (sala.rooms === "interna" || sala.rooms === "entrambe");
  const wantD = sala.excl_deorsi && (sala.rooms === "deorsi" || sala.rooms === "entrambe");
  if (wantI && wantD) return [mk("Entrambe le sale in uso esclusivo", config.prezzo_excl_entrambe || 1300)];
  if (wantI) return [mk("Sala Interna in uso esclusivo", config.prezzo_excl_interna || 500)];
  if (wantD) return [mk("Sala Dehors in uso esclusivo", config.prezzo_excl_deorsi || 800)];
  return [];
}

export function legacySalaToNew(sala, fallback) {
  if (!sala?.choice) return sala || fallback;
  const map = {
    interna: { rooms: "interna" },
    deorsi: { rooms: "deorsi" },
    excl_interna: { rooms: "interna", excl_interna: true },
    excl_deorsi: { rooms: "deorsi", excl_deorsi: true },
    excl_entrambe: { rooms: "entrambe", excl_interna: true, excl_deorsi: true },
  };
  return { ...fallback, ...map[sala.choice], assignment: sala.assignment || fallback.assignment };
}

export const FOOD_SERVICE_LABELS = { buffet: "a Buffet", tavola: "Seduti a Tavola", misto: "Misto Tavola + Buffet" };
export const GROUP_LABELS = { adulti: "Adulti", ragazzi: "Ragazzi", bambini: "Bambini" };
export const TORTA_SERVICE_PP = 2;
export const TORTA_KG_PRICE = 30;
export const TORTA_GR_PP = 80;

export function guestCounts(guests) {
  return { adulti: Number(guests.adults) || 0, ragazzi: Number(guests.teens) || 0, bambini: Number(guests.children) || 0 };
}

export function foodItems(food, guests) {
  const items = [];
  const counts = guestCounts(guests);
  const groups = food?.groups || {};
  Object.entries(counts).forEach(([g, n]) => {
    const cfg = groups[g];
    const b = Number(cfg?.budget_pp) || 0;
    if (n > 0 && b > 0) {
      items.push({ product_id: `food-${g}`, name: `Food ${GROUP_LABELS[g]} ${FOOD_SERVICE_LABELS[cfg.service] || "a Buffet"} — budget ${b} €/persona`, category: "Food", price: b, vat: 10, unit: "persona", qty: n, discount: 0 });
    }
  });
  const tot = counts.adulti + counts.ragazzi + counts.bambini;
  if (food?.torta === "esterna" && tot > 0) {
    items.push({ product_id: "torta-esterna", name: "Servizio torta (pasticceria esterna)", category: "Food", price: TORTA_SERVICE_PP, vat: 10, unit: "persona", qty: tot, discount: 0 });
  }
  if (food?.torta === "bliss" && tot > 0) {
    const kg = Math.round(tot * (TORTA_GR_PP / 1000) * 100) / 100;
    items.push({ product_id: "torta-bliss", name: `Torta Bliss ~${kg} kg (indicativo, da ${TORTA_KG_PRICE} €/kg)`, category: "Food", price: Math.round(kg * TORTA_KG_PRICE * 100) / 100, vat: 10, unit: "fisso", qty: 1, discount: 0 });
  }
  return items;
}

export function legacyFoodToNew(food, fallback) {
  if (!food || food.groups) return food || fallback;  if (!food.service) return fallback;
  const groups = {};
  ["adulti", "ragazzi", "bambini"].forEach((g) => {
    const svc = food.service === "misto" ? (food.assignment?.[g] || "buffet") : food.service;
    groups[g] = { service: svc === "misto" ? "buffet" : svc, budget_pp: Number(food.budget_pp) || 0 };
  });
  return { groups, torta: "nessuna" };
}

export function buildWhatsAppText(data, items, totals, config = {}) {
  const durata = config.durata_standard_ore || 3;
  const lines = [
    `*Richiesta preventivo — Bliss Café*`,
    ``,
    `\u{1F464} ${data.contact.name} — ${data.contact.phone}`,
    `\u{1F389} ${data.event.type}${data.event.type_custom ? ` (${data.event.type_custom})` : ""} il ${data.event.date}`,
    `\u{1F550} dalle ${data.event.time_start} alle ${data.event.time_end}${data.event.extra_hours > 0 ? ` (${durata} ore incluse + ${data.event.extra_hours} extra)` : ""}`,
    `\u{1F465} ${data.guests.adults} adulti + ${data.guests.teens || 0} ragazzi + ${data.guests.children} bambini`,
  ];
  if (data.sala && (data.sala.rooms || data.sala.choice)) {
    let salaLine = `\u{1F3DB} ${salaSummary(data.sala)}`;
    if (data.sala.rooms === "entrambe" && data.sala.assignment) {
      const a = data.sala.assignment;
      const roomName = (r) => (r === "deorsi" ? "Dehors" : "Interna");
      salaLine += ` (adulti: ${roomName(a.adulti)}, ragazzi: ${roomName(a.ragazzi)}, bambini: ${roomName(a.bambini)})`;
    }
    lines.push(salaLine);
  }
  if (data.food?.groups) {
    const counts = guestCounts(data.guests);
    const parts = Object.entries(counts)
      .filter(([, n]) => n > 0)
      .map(([g]) => `${GROUP_LABELS[g]} ${FOOD_SERVICE_LABELS[data.food.groups[g]?.service] || "a Buffet"}${Number(data.food.groups[g]?.budget_pp) > 0 ? ` (${data.food.groups[g].budget_pp} €/pp)` : ""}`);
    if (parts.length) lines.push(`\u{1F37D}\uFE0F Food: ${parts.join(" · ")}`);
    if (data.food.torta === "esterna") lines.push(`\u{1F382} Torta da pasticceria esterna (servizio ${TORTA_SERVICE_PP} €/persona)`);
    if (data.food.torta === "bliss") lines.push(`\u{1F382} Torta fornita da Bliss (da ${TORTA_KG_PRICE} €/kg, prezzo indicativo)`);
    if (data.food.note) lines.push(`\u{1F4DD} Preferenze food: ${data.food.note}`);
  }
  if (data.guests.dietary) lines.push(`\u26A0\uFE0F Esigenze: ${data.guests.dietary}`);
  lines.push(``, `*Voci selezionate:*`);
  items.forEach((it) => lines.push(`• ${it.name} x${it.qty} — ${fmtEur(it.price * it.qty)}`));
  lines.push(``, `*Totale indicativo: ${fmtEur(totals.total)}* (IVA inclusa)`);
  if (data.contact.notes) lines.push(``, `Note: ${data.contact.notes}`);
  return encodeURIComponent(lines.join("\n"));
}

export function buildClientReminderUrl(q) {
  const digits = q.contact.phone.replace(/\D/g, "");
  const intl = digits.startsWith("00") ? digits.slice(2) : digits.startsWith("39") && digits.length > 10 ? digits : `39${digits}`;
  const ev = `${q.event.type}${q.event.type_custom ? ` (${q.event.type_custom})` : ""} del ${q.event.date}`;
  const total = fmtEur(q.totals.total);
  const msgs = {
    nuovo: `Ciao ${q.contact.name}! Ti scriviamo dal Bliss Café.\nAbbiamo ricevuto la tua richiesta di preventivo n. ${q.number} per ${ev}.\nLa stiamo esaminando e ti risponderemo al più presto!`,
    in_revisione: `Ciao ${q.contact.name}! Ti scriviamo dal Bliss Café.\nIl tuo preventivo n. ${q.number} per ${ev} è in lavorazione: stiamo definendo gli ultimi dettagli e ti aggiorniamo a breve!`,
    approvato: `Ciao ${q.contact.name}! Ottime notizie dal Bliss Café!\nIl tuo preventivo n. ${q.number} per ${ev} è stato APPROVATO!\nTotale: ${total}\nPer bloccare la data ti chiediamo di versare l'acconto come indicato nel PDF che hai ricevuto. Per qualsiasi dubbio siamo qui!`,
    acconto_ricevuto: `Ciao ${q.contact.name}! Ti confermiamo di aver ricevuto l'acconto per il preventivo n. ${q.number} (${ev})!\nManca solo la conferma finale e poi è tutto pronto!`,
    confermato: `Ciao ${q.contact.name}! Il tuo evento è CONFERMATO!\n${ev} — preventivo n. ${q.number}, totale ${total}.\nTi aspettiamo al Bliss Café! Se hai esigenze dell'ultimo minuto scrivici pure qui.`,
    completato: `Ciao ${q.contact.name}! Grazie di cuore per aver festeggiato con noi al Bliss Café!\nSperiamo sia andato tutto alla grande — ti aspettiamo presto per il prossimo evento!`,
    rifiutato: `Ciao ${q.contact.name}, ti scriviamo dal Bliss Café riguardo al preventivo n. ${q.number} per ${ev}. Purtroppo non possiamo confermarlo, ma contattaci: troveremo insieme un'alternativa!`,
  };
  const text = msgs[q.status] || msgs.nuovo;
  return `https://wa.me/${intl}?text=${encodeURIComponent(text)}`;
}

export function buildTableConfirmUrl(r) {
  const digits = (r.phone || "").replace(/\D/g, "");
  const intl = !digits ? "" : digits.startsWith("00") ? digits.slice(2) : digits.startsWith("39") && digits.length > 10 ? digits : `39${digits}`;
  const d = new Date(`${r.date}T12:00:00`);
  const giorni = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  const dataIt = isNaN(d) ? (r.date || "") : `${giorni[d.getDay()]} ${d.getDate()}/${String(d.getMonth() + 1).padStart(2, "0")}`;
  const text = `Ciao ${r.name}! Ti scriviamo dal Bliss Cafè: il tuo tavolo per ${r.people} person${r.people === 1 ? "a" : "e"} ${dataIt}${r.time ? ` alle ${r.time}` : ""} è CONFERMATO!\nTi ringraziamo per averci scelto. Per qualsiasi cosa ci puoi contattare tramite WhatsApp.`;
  return `https://wa.me/${intl}?text=${encodeURIComponent(text)}`;
}
